import { MouseEventHandler } from 'react'

import { CommonSmallVerticalArrowTriangle2Icon } from '@local/assets/icons'

import Clickable from '@web/components/Clickable'
import Image from '@web/components/Image'
import { MissionLabel } from '@web/gql/graphql'
import { Nullish } from '@web/types'

import styles from '../MissionCard.module.scss'
import Label from './Label'

export interface TitleProps {
  title: string
  emojiUrl?: Nullish<string>
  label?: Nullish<MissionLabel>
  folded?: boolean
  foldable?: boolean
  onClick?: MouseEventHandler<HTMLButtonElement>
}

const Title = ({ title, emojiUrl, label, folded, foldable, onClick }: TitleProps) => {
  return (
    <Clickable
      className={styles.tit_area}
      disabled={!foldable}
      onClick={onClick}
      aria-haspopup="true"
      aria-expanded={foldable && !folded}
    >
      {title}
      {emojiUrl && <Image src={emojiUrl} width={19} height={19} className={styles.icon_emoji} alt="" />}
      {label && <Label label={label} />}
      {foldable && <CommonSmallVerticalArrowTriangle2Icon className={styles.icon_arrow} aria-hidden="true" />}
    </Clickable>
  )
}

export default Title
